import classNames from 'classnames'
import React, { useEffect, useState ,useRef, useContext, Fragment} from 'react'
import DropDownUser from './DropDownUser'
import ModalComments from './ModalComments'
import './Home.css'
import { TokenContext } from './Contexts/TokenContext'
import axios from 'axios'

export default function Post({closeModal=false,classname,commentClassname='hidden',profileImage="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460__340.png",postId,title,contentPost,authorUsername="mohanned",imagePost="https://images.unsplash.com/photo-1610147323479-a7fb11ffd5dd?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1534&q=80",createTime="10 hours ago",commentsCount}) {
    const {isToken} = useContext(TokenContext)
    const ref = useRef()
    const [isLike,setIsLike] = useState(false)
    const [isSaved,setIsSaved] = useState(false)
    let [isOpen, setIsOpen] = useState(false)
    let [isMenuOpen , setIsMenuOpen] = useState(false)
    const [comments,setComments] = useState([])

    // const [title,setTitle] = useState('')
    // const [contentPost,setContnetPost] = useState('')
    // const [nameAuthor,setNameAuthor] = useState('')
    // const [commentsCount,setCommentsCount] = useState('')
    // const [title,setTitle] = useState('')
    const list = [
        {key : 1,name: "Edit" , icon:"fa-sharp fa-solid fa-pen",classname: "!mr-0",link:""},
        {key : 2,name: "Delete" , icon:"fa-sharp fa-solid fa-trash ",classname: "!mr-0",link:""},
    ]
    const [message,setMessage] = useState('')
    // function handlePostClicked(id){
    //     axios.get(`https://tarmeezacademy.com/api/v1/posts/${id}`)
    //     .then((resp)=> {
    //         let response = resp.data.data
    //         setComments(response.comments)
        
    //     })
    //     .catch((error) => console.log(error))
    // }
    useEffect(() => {
        
        const checkIfClickedOutside = e => {
          if (isMenuOpen && ref.current && !ref.current.contains(e.target)) {
            setIsMenuOpen(false)
          }
        }
        document.addEventListener("mousedown", checkIfClickedOutside)
        return () => {
          document.removeEventListener("mousedown", checkIfClickedOutside)
        }
        
      }, [isMenuOpen,<ModalComments/>])


      const handleChange = (event) => {
        setMessage(event.target.value);
      };
      const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
          event.target.value=""
        }
      };
    
    return (
       
            <main className="w-full md:w-[98%]  flex items-center justify-center  px-5 mt-5 " >
                <div className="border max-w-screen-md bg-white mt-6 rounded-2xl p-4 w-full">
                    <div className="flex items-center	justify-between">
                        <div className="gap-3.5	flex items-center w-full justify-start relative">
                          {typeof profileImage!= 'object' ? <img src={profileImage} className="object-cover bg-yellow-500 rounded-full w-10 h-10" />: <img src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460__340.png" className="object-cover bg-yellow-500 rounded-full w-10 h-10" />}  
                            <div className="flex flex-col grow">
                                <b className="mb-2 capitalize">@{authorUsername}</b>
                                {/* <time datetime="06-08-21" className="text-gray-400 text-xs">06 August at 09.15 PM
                                </time> */}
                                <span className="text-gray-600 text-sm">{createTime}</span>
                            </div>
                            {isToken ?
                            <Fragment>
                            <DropDownUser list={list} classname={classNames("bgDropDown bg-white text-black w-60 py-5 px-2 h-[100px]",{
                                " hidden" : !isMenuOpen,
                                "showMenuCRUD" : isMenuOpen
                            })} classList=" rounded-xl h-10 pt-1 my-[-5px] md:my-0"  />
                               <div className='w-[40px] text-center cursor-pointer' onClick={() => setIsMenuOpen((prev) => !prev) } ref={ref} >
                                    <i className="fa-solid fa-ellipsis-vertical "></i>
                                </div> 
                                <ModalComments isOpen={isOpen} setIsOpen={setIsOpen}/>
                            </Fragment>:
                            <Fragment>
                                <ModalComments postId={postId} isOpen={isOpen} setIsOpen={setIsOpen}/>
                            </Fragment>
                            }
                                
                        </div>
                        <div className="bg-gray-100	rounded-full h-3.5 flex	items-center justify-center" >
                        </div>
                    </div>
                    <div className="whitespace-pre-wrap mt-7">{contentPost}</div>
                    <div className="mt-5 flex gap-2	 justify-center border-b pb-4 flex-wrap	">
                     <img  src={imagePost} className={classNames("rounded-2xl w-1/3 object-cover h-96 flex-auto",{
                        'block' : imagePost!= null,
                        'hidden': typeof imagePost === 'object'
                     })} alt="photo" />
                    </div>
                    <div className=" h-16 border-b  flex items-center justify-around	">
                        <div className="flex items-center	gap-3	">
                            <div className="text-sm cursor-pointer	" onClick={() => setIsOpen((prev)=>!closeModal)} ><i className="fa-regular fa-comment fa-lg"></i> {commentsCount} Comments</div>
                        </div>
                        
                            {isToken?
                            <Fragment>
                                <div className="flex items-center	gap-3">
                                <div className="text-sm cursor-pointer" onClick={() => setIsLike((prev) => !prev) }>
                                    <i className={classNames('fa-heart fa-lg ',{
                                                "fa-solid  text-red-600":isLike,
                                                "fa-regular text-black":!isLike
                                            })} ></i> {isLike? 1 : 0} Likes</div>
                                            </div>
                                            <div className="flex items-center	gap-3">
                                                <div className="text-sm cursor-pointer"><i className="fa-regular fa-share-from-square"></i> Share</div>
                                            </div>
                                        <div className=" items-center gap-3 hidden sm:flex">
                                                <div className="text-sm cursor-pointer" onClick={() => setIsSaved((prev) => !prev) }><i 
                                                    className={classNames('fa-bookmark fa-lg ',{
                                                        "fa-solid  text-yellow-500":isSaved,
                                                        "fa-regular text-black":!isSaved
                                                    })} ></i> {isSaved? 1 : 0} Saved
                                                </div>
                        </div>
                            </Fragment>:
                            <Fragment>
                                <div className="flex items-center	gap-3">
                                <div className="text-sm cursor-pointer" onClick={() => setIsOpen((prev)=>!closeModal) }>
                                    <i className={classNames('fa-heart fa-lg ',{
                                                "fa-solid  text-red-600":isLike,
                                                "fa-regular text-black":!isLike
                                            })} ></i> {isLike? 1 : 0} Likes</div>
                                            </div>
                                            <div className="flex items-center	gap-3">
                                                 <div className="text-sm cursor-pointer" onClick={() => setIsOpen((prev)=>!closeModal)}><i className="fa-regular fa-share-from-square"></i> Share</div>
                                            </div>
                                            <div className=" items-center gap-3 hidden sm:flex" onClick={() => setIsOpen((prev)=>!closeModal) }>
                                                <div className="text-sm cursor-pointer" onClick={() => setIsSaved((prev) => !prev) }><i 
                                                    className={classNames('fa-regular fa-bookmark fa-lg ',{
                                                        
                                                    })} ></i> Saved
                                                </div>
                        </div>
                            </Fragment>
                        }
                            
                        
                        
                       
                        </div>
                    <div className={classNames('my-5 gap-7 flex-col',commentClassname)} >
                        <div className='comment flex gap-2'>
                            <img src="https://images.unsplash.com/photo-1595152452543-e5fc28ebc2b8?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80" className="bg-yellow-500 rounded-full w-10 h-10 object-cover border" />
                            <div className='bg-[#F0F2F5] rounded-2xl w-10/12 p-4'>
                                <span className='font-bold'>Valery ForVendetta Mollica</span>
                                <p>There are other adverbs like them with there, where and here — they must be called compound adverbs or something, ie. Therein, thereof, thereon, whereof, whereon, herein, hereby. It would be best if you did a whole article about all of them.</p>
                            </div>
                        </div>
                        <div className='comment flex gap-2'>
                            <img src="https://images.unsplash.com/photo-1595152452543-e5fc28ebc2b8?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80" className="bg-yellow-500 rounded-full w-10 h-10 object-cover border" />
                            <div className='bg-[#F0F2F5] rounded-2xl w-10/12 p-4'>
                                <span className='font-bold'>Valery ForVendetta Mollica</span>
                                <p>There are other adverbs like them with there, where and here — they must be called compound adverbs or something, ie. Therein, thereof, thereon, whereof, whereon, herein, hereby. It would be best if you did a whole article about all of them.</p>
                            </div>
                        </div>
                        <div className='comment flex gap-2'>
                            <img src="https://images.unsplash.com/photo-1595152452543-e5fc28ebc2b8?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80" className="bg-yellow-500 rounded-full w-10 h-10 object-cover border" />
                            <div className='bg-[#F0F2F5] rounded-2xl w-10/12 p-4'>
                                <span className='font-bold'>Valery ForVendetta Mollica</span>
                                <p>There are other adverbs like them with there, where and here — they must be called compound adverbs or something, ie. Therein, thereof, thereon, whereof, whereon, herein, hereby. It would be best if you did a whole article about all of them.</p>
                            </div>
                        </div>
                        
                    </div>
                    <div className="flex items-center mt-4 gap-2">
                        <img src="https://images.unsplash.com/photo-1595152452543-e5fc28ebc2b8?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80" className="bg-yellow-500 rounded-full w-10 h-10 object-cover border" />
                        <div className= {classNames('flex items-center	justify-between	 bg-gray-50 h-11 w-11/12 border rounded-2xl	 overflow-hidden px-4',classname)}>
                            <input type="text" className="h-full w-full bg-gray-50 outline-none  " placeholder="Write your comment..." name="comment" onClick={() => setIsOpen((prev)=>!closeModal)} onChange={handleChange} onKeyDown={handleKeyDown}/>
                        </div>
                    </div>
                </div>

                
            </main>
    )
}
